import { useCurrentTeam } from '@/providers/TeamProvider';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useMonthlyOrderingBudgets } from '@/hooks/api/0240_monthly_ordering_budgets';

export const MonthlyOrderingBudgetsElement = () => {
  const { _w_, me, _t_, isAdmin } = useCurrentTeam();
  const { data } = useMonthlyOrderingBudgets({ identifier: _w_!.identifier, team_id: _t_!.id });
  const [monthLabels, setMonthLabels] = useState<number[]>();

  useEffect(() => {
    const closingMonth = moment(_w_!.closing_month, 'MM');
    const _monthLabels = [...Array(12)].map(() => {
      closingMonth.add(1, 'month');
      return closingMonth.toDate().getMonth() + 1;
    });

    setMonthLabels(_monthLabels);
  }, []);

  return (
    <div className="card mb-4">
      <div className="card-header d-flex align-items-center">
        <div className="col-md-8">
          <h5 className="mb-1">チーム予算</h5>
          <p className="text-xs mb-0">設定すると、ダッシュボードで予算と実績の差分を見ることができます</p>
        </div>
        <div className="col-md-4 d-flex justify-content-end">
          {isAdmin && (
            <Link
              to={`/w/${_w_!.identifier}/setting/teams/${_t_!.id}/monthly_ordering_budgets`}
              className="btn bg-gradient-primary btn-icon"
            >
              <i className="fas fa-edit"></i>予算設定
            </Link>
          )}
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="table-responsive">
          <table className="table align-items-center">
            <thead>
              <tr>
                <th className="bg-white" style={{ position: 'sticky', left: 0, zIndex: 999 }}>
                  &nbsp;
                </th>
                {monthLabels?.map((m) => (
                  <th
                    key={`m-label-${m}`}
                    className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  >
                    {m}月
                  </th>
                ))}
                <th
                  className="text-uppercase text-secondary text-xxs font-weight-bolder px-2 bg-white"
                  style={{ position: 'sticky', right: 0, zIndex: 999 }}
                >
                  合計
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-xs text-dark font-weight-bold bg-white" style={{ position: 'sticky', left: 0 }}>
                  前期
                </td>
                {data?.previous_ordering_budgets.map((d, i) => (
                  <td key={`p-o-${i}`} className="text-xxs">
                    ¥{d.amount.toLocaleString()}
                  </td>
                ))}
                <td className="text-xxs text-dark font-weight-bold bg-white" style={{ position: 'sticky', right: 0 }}>
                  ¥{data?.previous_ordering_budgets.reduce((sum, d) => sum + d.amount, 0).toLocaleString()}
                </td>
              </tr>
              <tr>
                <td
                  className="text-xs text-dark font-weight-bold bg-table-even"
                  style={{ position: 'sticky', left: 0 }}
                >
                  今期
                </td>
                {data?.current_ordering_budgets.map((d, i) => (
                  <td key={`c-o-${i}`} className="text-xxs">
                    ¥{d.amount.toLocaleString()}
                  </td>
                ))}
                <td
                  className="text-xxs text-dark font-weight-bold bg-table-even"
                  style={{ position: 'sticky', right: 0 }}
                >
                  ¥{data?.current_ordering_budgets.reduce((sum, d) => sum + d.amount, 0).toLocaleString()}
                </td>
              </tr>
              <tr>
                <td className="text-xs text-dark font-weight-bold bg-white" style={{ position: 'sticky', left: 0 }}>
                  来期
                </td>
                {data?.next_ordering_budgets.map((d, i) => (
                  <td key={`n-o-${i}`} className="text-xxs">
                    ¥{d.amount.toLocaleString()}
                  </td>
                ))}
                <td className="text-xxs text-dark font-weight-bold bg-white" style={{ position: 'sticky', right: 0 }}>
                  ¥{data?.next_ordering_budgets.reduce((sum, d) => sum + d.amount, 0).toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
